import { Mail, Phone, MapPin } from 'lucide-react';
import SEO from './SEO';


const ContactUs = () => {

  const contactInfo = [
    {
      icon: Mail,
      title: 'Email Us',
      content: 'helps.vihaanherbals@gmail.com',
      link: 'mailto:helps.vihaanherbals@gmail.com'
    },
    {
      icon: Phone,
      title: 'Call Us',
      content: '+91 7383706319',
      link: 'tel:+917383706319'
    },
    {
      icon: MapPin,
      title: 'Visit Us',
      content: 'Mangaldeep, Opp Anand flats, Ahmedabad, Gujarat, India',
      link: null
    }
  ];

  return (
    <div className="bg-gradient-to-br from-gray-50 via-white to-gray-50">
      <SEO 
        title="Contact Us - We're Here to Help"
        description="Have questions about our herbal products? Reach out to Vihaan Herbals via email, phone, or visit our store in Ahmedabad. We value your feedback."
      />

      {/* Hero Section */}
      <div className="bg-gradient-to-r from-green-600 to-emerald-700 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 sm:py-28" style={{ paddingTop: '1rem', paddingBottom: '1rem' }}>
          <div className="text-center">
            <div className="inline-flex items-center justify-center w-20 h-20 sm:w-24 sm:h-24 bg-white/20 rounded-full mb-6 backdrop-blur-sm">
              <Mail className="text-4xl sm:text-5xl text-white w-10 h-10 sm:w-12 sm:h-12" />
            </div>
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold mb-4 sm:mb-6">
              Get In Touch
            </h1>
            <p className="text-lg sm:text-xl text-green-50 max-w-3xl mx-auto px-4">
              Have a question or need assistance? We're here to help! Reach out to us and we'll get back to you as soon as possible.
            </p>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12">
          {/* Contact Information */}
          <div className="space-y-6">
            <div className="bg-white rounded-2xl shadow-lg p-6 sm:p-8 border border-gray-100">
              <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-6 sm:mb-8">
                Contact Information
              </h2>
              <div className="space-y-6">
                {contactInfo.map((info, index) => {
                  const Icon = info.icon;
                  return (
                    <div key={index} className="flex items-start gap-4">
                      <div className="w-12 h-12 bg-gradient-to-br from-green-500 to-emerald-600 rounded-lg flex items-center justify-center flex-shrink-0">
                        <Icon className="text-white w-6 h-6" />
                      </div>
                      <div className="flex-1">
                        <h3 className="text-lg font-semibold text-gray-900 mb-1">
                          {info.title}
                        </h3>
                        {info.link ? (
                          <a
                            href={info.link}
                            className="text-green-600 hover:text-green-700 font-medium transition-colors duration-200 break-words"
                          >
                            {info.content}
                          </a>
                        ) : (
                          <p className="text-gray-600 break-words">
                            {info.content}
                          </p>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>

          {/* Business Hours */}
          <div className="space-y-6">
            <div className="bg-gradient-to-br from-green-50 to-emerald-50 rounded-2xl shadow-lg p-6 sm:p-8 border border-green-100">
              <h3 className="text-xl font-bold text-gray-900 mb-4">
                Business Hours
              </h3>
              <div className="space-y-2 text-gray-700">
                <div className="flex justify-between">
                  <span className="font-medium">Monday - Friday</span>
                  <span>9:00 AM - 6:00 PM</span>
                </div>
                <div className="flex justify-between">
                  <span className="font-medium">Saturday</span>
                  <span>10:00 AM - 4:00 PM</span>
                </div>
                <div className="flex justify-between">
                  <span className="font-medium">Sunday</span>
                  <span>Closed</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;

